import { c as _c } from "react/compiler-runtime";
import { css } from '@repo/pandacss/css';
import type { JsxStyleProps } from '@repo/pandacss/types';
import { Skeleton } from '@repo/ui/Skeleton';
const styles = {
  root: css({
    display: {
      base: 'none',
      _pcMd: 'flex'
    },
    flexDirection: 'column',
    position: 'relative',
    mb: '3.5',
    borderWidth: '[1px]',
    borderStyle: 'solid',
    borderColor: 'grey.200',
    borderRadius: 'md',
    width: '[100%]'
  }),
  inner: css({
    px: '3.5',
    pt: '3.5',
    pb: '[0.75rem]',
    width: '[100%]'
  }),
  spotlightRow: css({
    display: 'flex',
    alignItems: 'center',
    mb: '3',
    width: '[100%]'
  }),
  badgeRow: css({
    display: 'flex',
    alignItems: 'center',
    pb: '4',
    width: '[100%]'
  }),
  contentRow: css({
    display: 'flex',
    alignItems: 'center',
    pb: '3',
    gap: '4',
    width: '[100%]'
  }),
  contentInfoColumn: css({
    flex: '1',
    display: 'flex',
    flexDirection: 'column',
    gap: '2'
  }),
  applyColumn: css({
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    gap: '2'
  }),
  driverRow: css({
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    pb: '3',
    width: '[100%]'
  }),
  driverRowLast: css({
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    pb: '4',
    width: '[100%]'
  }),
  driverCell: css({
    flex: '1',
    px: '2'
  }),
  accordionRow: css({
    display: 'flex',
    width: '[100%]',
    borderTopWidth: '[1px]',
    borderTopStyle: 'solid',
    borderTopColor: 'grey.200',
    py: '[calc(0.5rem+12px)]'
  })
} as const;
const roundedSkeleton = (sizeCss: JsxStyleProps['css']) => <Skeleton variant="rounded" css={sizeCss} />;
export function DesktopSkeleton() {
  const $ = _c(6);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div className={styles.badgeRow}>{roundedSkeleton({
        width: "[250px]",
        height: "[40px]"
      })}</div>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <div>{roundedSkeleton({
        width: "[200px]",
        height: "[105px]"
      })}</div>;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <div className={styles.contentInfoColumn}>{roundedSkeleton({
        width: "[350px]",
        height: "[30px]"
      })}{roundedSkeleton({
        width: "[250px]",
        height: "[25px]"
      })}{roundedSkeleton({
        width: "[125px]",
        height: "[27.5px]"
      })}</div>;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <div className={styles.contentRow}>{t1}{t2}<div className={styles.applyColumn}>{roundedSkeleton({
          width: "[250px]",
          height: "[50px]",
          mb: "1"
        })}{roundedSkeleton({
          width: "[150px]",
          height: "[20px]"
        })}</div></div>;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <div className={styles.driverRow}>{[0, 1, 2, 3].map(_temp)}</div>;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <div className={styles.root}><div className={styles.inner}>{t0}{t3}{t4}<div className={styles.driverRowLast}>{[0, 1, 2, 3].map(_temp2)}</div></div>{[0, 1, 2].map(_temp3)}</div>;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  return t5;
}
function _temp3(idx) {
  return <div key={`accordion-${idx}`} className={styles.accordionRow}>{roundedSkeleton({
      width: "[30px]",
      height: "[27px]",
      ml: "3.5",
      mr: "2"
    })}{roundedSkeleton({
      width: "[250px]",
      height: "[27px]"
    })}</div>;
}
function _temp2(n_0) {
  return <div key={n_0} className={styles.driverCell}>{roundedSkeleton({
      width: "[100%]",
      height: "[75px]"
    })}</div>;
}
function _temp(n) {
  return <div key={n} className={styles.driverCell}>{roundedSkeleton({
      width: "[100%]",
      height: "[75px]"
    })}</div>;
}